/**
 * Market Definitions
 * Places where players SELL fish and access quest boards
 */

import { MarketDefinition, MarketType, ShopCategory } from '@/types';

/**
 * Camp Chef - Starter market in Mountain Lake
 * Unlocked by default, basic prices, simple quests
 */
export const CAMP_CHEF_MARKET: MarketDefinition = {
  id: 'camp_chef',
  category: ShopCategory.MARKET,
  subtype: MarketType.CAMP_CHEF,
  name: "Camp Chef",
  description: "A friendly camp chef who'll buy your catch and share stories about the lake.",
  zoneId: 'mountain_lake',

  // Unlocked by default
  unlockedByDefault: true,

  // Fish selling prices (base multiplier)
  fishPriceMultiplier: 1.0, // 100% of base price
  // Accepts all fish

  // Quest board
  questBoard: {
    maxActiveQuests: 8, // Show up to 8 quests at a time (allows multiple active simultaneously)
    refreshInterval: 24, // Refresh daily (24 hours)
    proceduralQuestPool: [
      'proc_catch_quantity',
      'proc_catch_quality',
      'proc_catch_species',
    ],
    buddyQuestPool: [
      'proc_buddy_catch_quantity',
      'proc_buddy_catch_species',
      'proc_hauler_sell_quantity',
      'proc_hauler_earn_gold',
    ],
    curatedQuestPool: [
      'tut_first_cast',
      'tut_first_sale',
      'tut_buddy_system',
    ],
    proceduralWeight: 0.6, // 60% procedural, 40% curated
  },

  // Visual
  npcName: "Chef Marco",
  npcDialogue: [
    "Ah, fresh catch! Bellissimo!",
    "I'll pay fair prices for your fish — and a squeeze of lemon!",
    "Got any big ones? Marco needs only the FINEST.",
    "The camp's getting hungry! Andiamo!",
  ],
};

/**
 * All market definitions
 */
export const MARKET_DEFINITIONS: MarketDefinition[] = [
  CAMP_CHEF_MARKET,
];
